// redux/Modules/subModules/actions.js

import { APICall } from "@/config/NetworkUtility";

import {
    SUB_MODULE_DELETE,
    SUB_MODULE_INSERT,
  SUB_MODULE_UPDATE,
  SUB_MODULES_LIST,
  SUB_MODULES_PAGINATION,
} from "./constant";

import { callLoader } from "@/redux/Loader/actions";
import { logApiError } from "@/services/apiErrorLogger";


// ======================================
// GET SUB MODULES
// ======================================

export const getSubModules =
  (payload) =>
  async (dispatch) => {
    try {
      dispatch(callLoader(true));

      const queryParams = new URLSearchParams({
        ...payload,
      }).toString();

      const url =
        `v1/ModuleSetup/GetSubModuleList?${queryParams}`;

      const result = await APICall(
        "get",
        payload,
        url,
      );

      if (
        result?.statuscode === 200 ||
        result?.statuscode === 201
      ) {
        dispatch({
          type: SUB_MODULES_LIST,
          payload: result?.data || [],
        });

        dispatch({
          type: SUB_MODULES_PAGINATION,
          payload:
            result?.pagination || {},
        });

        return result?.data || [];
      }

      return Promise.reject(result);
    } catch (error) {
      logApiError(error, {
        source: "sub-modules",
        endpoint: "GetSubModuleList",
        payload,
      });

      return Promise.reject(error);
    } finally {
      dispatch(callLoader(false));
    }
        };

// ======================================
// INSERT
// ======================================
        export const insertSubModule = (payload) => async (dispatch) => {
  try {
    dispatch(callLoader(true));

    const url = `v1/ModuleSetup/SubModuleInsert`;

    const result = await APICall("post", payload, url, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (result?.statuscode === 200 || result?.statuscode === 201) {
      dispatch({
        type: SUB_MODULE_INSERT,
        payload: result?.data || result,
      });

      return result;
    }

    return Promise.reject(result);
  } catch (error) {
    logApiError(error, {
      source: "insertSubModule",
      endpoint: "SubModuleInsert",
      payload: "[FormData]",
    });

    return Promise.reject(error);
  } finally {
    dispatch(callLoader(false));
  }
};

// ======================================
// UPDATE
// ======================================

export const updateSubModule = (payload) => async (dispatch) => {
  try {
    dispatch(callLoader(true));

    const url = `v1/ModuleSetup/SubModuleUpdate`;

    const result = await APICall("post", payload, url, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (result?.statuscode === 200 || result?.statuscode === 201) {
      dispatch({
        type: SUB_MODULE_UPDATE,
        payload: result?.data || result,
      });

      return result;
    }

    return Promise.reject(result);
  } catch (error) {
    logApiError(error, {
      source: "updateSubModule",
      endpoint: "SubModuleUpdate",
      payload: "[FormData]",
    });

    return Promise.reject(error);
  } finally {
    dispatch(callLoader(false));
  }
};

// ======================================
// DELETE
// ======================================

export const deleteSubModule = (payload) => async (dispatch) => {
  try {
    dispatch(callLoader(true));

    const url = `v1/ModuleSetup/DeleteSubModule`;

    const result = await APICall("post", payload, url, {
      headers: {
        accept: "*/*",
        "Content-Type": "application/json",
      },
    });

    if (result?.statuscode === 200 || result?.statuscode === 201) {
      dispatch({
        type: SUB_MODULE_DELETE,
        payload: payload?.SUBMODULE_ID,
      });

      return result;
    }

    return Promise.reject(result);
  } catch (error) {
    logApiError(error, {
      source: "deleteSubModule",
      endpoint: "DeleteSubModule",
      payload,
    });

    return Promise.reject(error);
  } finally {
    dispatch(callLoader(false));
  }
};